@if (siteContentService.socialLinksLoading()) {
    <div class="text-center text-muted-color py-6">Loading...</div>
} @else {
    <p-table
        [value]="siteContentService.socialLinks()"
        [showGridlines]="true"
        responsiveLayout="scroll">
        <ng-template #caption>
            <div class="flex justify-between items-center">
                <p-button label="New" icon="pi pi-plus" severity="success" [disabled]="availableSocialPlatforms().length === 0" (click)="openAddDialog()"></p-button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="Platform" style="min-width: 8rem">Platform <p-sortIcon field="Platform" /></th>
                <th pSortableColumn="Url" style="min-width: 16rem">URL <p-sortIcon field="Url" /></th>
                <th pSortableColumn="DisplayOrder" style="min-width: 6rem">Order <p-sortIcon field="DisplayOrder" /></th>
                <th>Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-link let-i="rowIndex">
            <tr>
                <td>
                    <p-tag [value]="link.Platform"></p-tag>
                </td>
                <td class="font-mono text-sm">{{ link.Url }}</td>
                <td>{{ link.DisplayOrder ?? '—' }}</td>
                <td>
                    <div class="flex items-center gap-2">
                        <p-button icon="pi pi-pencil" severity="warn" [rounded]="true" [outlined]="true" pTooltip="Edit" (click)="openEditDialog(i)"></p-button>
                        <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true" pTooltip="Delete" (click)="confirmDelete(i)"></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" class="text-center text-muted-color py-6">No social links found.</td>
            </tr>
        </ng-template>
    </p-table>
}

<!-- CRUD dialog -->
<p-dialog
    [header]="dialogMode() === 'add' ? 'New Social Link' : 'Edit Social Link'"
    [visible]="dialogVisible()"
    (visibleChange)="dialogVisible.set($event)"
    [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '40vw' }"
    [modal]="true"
>
    <p-fluid>
        <div class="flex flex-col gap-4">
            <div>
                <label class="block font-medium mb-1">Platform</label>
                <p-select
                    class="w-full"
                    [ngModel]="editPlatform()"
                    (ngModelChange)="editPlatform.set($event)"
                    [options]="availableSocialPlatforms()"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select platform..."
                />
            </div>
            <div>
                <label class="block font-medium mb-1">URL</label>
                <input pInputText class="w-full" [ngModel]="editUrl()" (ngModelChange)="editUrl.set($event ?? '')" />
            </div>
            <div>
                <label class="block font-medium mb-1">Display Order</label>
                <p-inputNumber class="w-full" [ngModel]="editDisplayOrder()" (ngModelChange)="editDisplayOrder.set($event)" [showButtons]="true" [allowEmpty]="true"></p-inputNumber>
            </div>
            @if (saveError()) {
                <div class="text-red-500 text-sm">{{ saveError() }}</div>
            }
        </div>
    </p-fluid>
    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" (click)="dialogVisible.set(false)"></p-button>
            <p-button label="Save" icon="pi pi-check" [loading]="saving()" (click)="saveLink()"></p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- Delete confirmation -->
<p-dialog
    header="Confirm Delete"
    [visible]="deleteDialogVisible()"
    (visibleChange)="deleteDialogVisible.set($event)"
    [style]="{ width: '28rem' }"
    [modal]="true"
>
    <div class="flex items-center gap-3">
        <i class="pi pi-exclamation-triangle text-3xl text-red-500"></i>
        <span>Are you sure you want to delete this social link?</span>
    </div>
    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" (click)="deleteDialogVisible.set(false)"></p-button>
            <p-button label="Delete" severity="danger" icon="pi pi-trash" (click)="executeDelete()"></p-button>
        </div>
    </ng-template>
</p-dialog>
